module.exports = __webpack_public_path__ + "static/makar-makarian-empowerment-hero-small-49d7b2d7586c124d17b57ae18a3d41ca.jpg";